import BloodPressure from './BloodPressure';

export default BloodPressure;
